import { useQuery } from '@tanstack/react-query';

import { searchPromoCampaigns } from '~/services/LuxLoyaltyService';

import type { PromoCampaignSearchParams } from '~/types/loyaltyContract';

import { promoCampaignQueryKeys } from './promoCampaignQueryKeys';

interface UseSearchPromoCampaignsOptions {
  enabled?: boolean;
}

export function useSearchPromoCampaigns(
  params: PromoCampaignSearchParams,
  options: UseSearchPromoCampaignsOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: promoCampaignQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await searchPromoCampaigns(params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
